import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import Form from 'app/components/Form';

import {
  getTags
} from 'app/services/tags';

import {
  formatOptions
} from 'app/utils/options';

const KioskUploadForm = props => {
  const {
    onClose,
    agGrid,
    action,
    onSubmit,
    storyIds,
    jobConfigs
  } = props;

  // filter out Digital Delivery product
  const jobConfigOptions = formatOptions(jobConfigs.filter(jc => jc.id !== -1));

  const getTagOptionIcon = record => {
    if (record.club_med_visit_id) {
      return PeopleIcon;
    }
    if (record.customer_id) {
      return PersonIcon;
    }
    if (record.job_id) {
      return CalendarMonthOutlinedIcon;
    }
  }

  const getTagOptionLabel = record => {
    if (record.club_med_visit_id) {
      return record.name;
    }
    if (record.customer_id) {
      return record.customer.name || record.customer.email || record.customer.access_code || record.customer.id.toString();
    }
    if (record.job_id) {
      return record.name;
    }
  }

  const getTagOptionGroup = record => {
    if (record.club_med_visit_id) {
      return 'Reservations';
    }
    if (record.customer_id) {
      return 'Customers';
    }
    if (record.job_id) {
      return 'Catalogs';
    }
  }

  const getTagOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let params = {
      page,
      per_page: perPage
    }

    let resp = await getTags(params);

    return formatOptions(resp.records, {
      value: 'story_id',
      icon: getTagOptionIcon,
      label: getTagOptionLabel,
      group: getTagOptionGroup
    });
  }

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  let fields = [
    { name: 'story_ids', label: 'Tags', type: 'autocomplete', value: storyIds || [], valueType: 'integer', getOptions: getTagOptions, multiple: true, groupBy: opt => opt.group },
    { name: 'job_config_id', label: 'Product', type: 'select', valueType: 'integer', options: jobConfigOptions },
    { name: 'files', label: 'Select Files', type: 'file', multiple: true }
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default KioskUploadForm;
